// import React, { Suspense, lazy } from "react";
// import { useParams } from "react-router-dom";
// import { Box, LinearProgress } from "@mui/material";

// const TwitterBioGenerator = lazy(() => import("./Pages/TwitterBioGenerator"));
// const PinterestBioGenerator = lazy(() => import("./Pages/PrinterestBioGenerator"));
// const SocialMediaBioGenerator = lazy(() => import("./Pages/SocialMediaBioGenerator"));
// const FacebookBioGenerator = lazy(() => import("./Pages/FacebookBioGenerator"));
// const TikTokBioGenerator = lazy(() => import("./Pages/TikTokBioGenerator"));
// const LinkedInBioGenerator = lazy(() => import("./Pages/LinkedInBioGenerator"));
// const BumbleBioGenerator = lazy(() => import("./Pages/BumbleBioGenerator"));
// const TinderBioGenerator = lazy(() => import("./Pages/TinderBioGenerator"));
// const InstagramBioGenerator = lazy(() => import("./Pages/InstagramBioGenerator"));

// export default function BioGenerator() {
//   let { slug } = useParams();

//   return (
//     <Suspense
//       fallback={
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             textAlign: "center",
//             width: "100%"
//           }}
//         >
//           <Box sx={{ display: "inline-block", width: "300px" }}>
//             <LinearProgress />
//           </Box>
//         </Box>
//       }
//     >
//       {(() => {
//         switch (slug) {
//           case "tiktok":
//             return <TikTokBioGenerator />;
//           case "instagram":
//             return <InstagramBioGenerator />;
//           case "twitter":
//             return <TwitterBioGenerator />;
//           case "pinterest":
//             return <PinterestBioGenerator />;
//           case "facebook":
//             return <FacebookBioGenerator />;

//           case "linkedin":
//             return <LinkedInBioGenerator />;
//           case "social-media":
//             return <SocialMediaBioGenerator />;
//           case "bumble":
//             return <BumbleBioGenerator />;
//           case "tinder":
//             return <TinderBioGenerator />;
//           default:
//             return null;
//         }
//       })()}
//     </Suspense>
//   );
// }

import React, { lazy } from "react";
import { useParams } from "react-router-dom";

const TwitterBioGenerator = lazy(() => import("./Pages/TwitterBioGenerator"));
const PinterestBioGenerator = lazy(() => import("./Pages/PrinterestBioGenerator"));
const SocialMediaBioGenerator = lazy(() => import("./Pages/SocialMediaBioGenerator"));
const FacebookBioGenerator = lazy(() => import("./Pages/FacebookBioGenerator"));
const TikTokBioGenerator = lazy(() => import("./Pages/TikTokBioGenerator"));
const LinkedInBioGenerator = lazy(() => import("./Pages/LinkedInBioGenerator"));
const BumbleBioGenerator = lazy(() => import("./Pages/BumbleBioGenerator"));
const TinderBioGenerator = lazy(() => import("./Pages/TinderBioGenerator"));
const InstagramBioGenerator = lazy(() => import("./Pages/InstagramBioGenerator"));

export default function BioGenerator() {
  let { slug } = useParams();

  //let BioComponent;
  switch (slug) {
    case "tiktok":
      return <TikTokBioGenerator />;
    case "instagram":
      return <InstagramBioGenerator />;
    case "twitter":
      return <TwitterBioGenerator />;
    case "pinterest":
      return <PinterestBioGenerator />;
    case "facebook":
      return <FacebookBioGenerator />;
    case "linkedin":
      return <LinkedInBioGenerator />;
    case "social-media":
      return <SocialMediaBioGenerator />;
    case "bumble":
      return <BumbleBioGenerator />;
    case "tinder":
      return <TinderBioGenerator />;
    default:
      return null;
  }
}
